<div class="back-btn exit-app" (click)="onBack()"></div>
<section
  id="storefront"
  class="storefront"
  [ngClass]="{ 'chromium-legacy': isLegacyChromium }"
>
  <!-- Sticky hero container -->
  <div class="hero-fixed-container" [class.carousel-type]="isHeroFocused">
    <ng-container
      *ngIf="
        carouselResources?.length > 0 && isHeroFocused;
        else contentDetailTemplate
      "
    >
      <div class="hero-details-data-buttons-watchnow">
        <!-- Title Section -->
        <ng-container *ngIf="titleImage?.length > 0; else customTitleBlock">
          <div class="hero-title-image-container vertical-ac">
            <img
              id="heroTitleImage"
              [ngStyle]="{
                visibility: isHeroImageLoaded ? 'visible' : 'hidden',
                opacity: isHeroImageLoaded ? 1 : 0
              }"
              [ngClass]="{ loaded: isHeroImageLoaded }"
              class="hero-details-data-image zoom-item"
              loading="eager"
              [src]="titleImage.replace('jpg', 'png')"
              [alt]="currentResource?.title[lang]"
              (load)="onImageLoad($event)"
            />
          </div>
        </ng-container>

        <ng-template #customTitleBlock>
          <div
            class="hero-details-data-title zoom-item"
            [style]="'fontSize.48' | translate"
          >
            {{ currentResource?.title[lang] }}
          </div>
        </ng-template>

        <!-- Ratings and Quality Section -->
        <div
          *ngIf="
            contentDetailInfo?.contentTags?.includes('trending') ||
            contentDetailInfo?.customTags?.length > 0 ||
            contentDetailInfo?.is4k ||
            contentDetailInfo?.isDolbyAudio ||
            contentDetailInfo?.isAtmos
          "
          class="hero-details-data-description-rating-quality horizontal-ac zoom-item"
        >
          <!-- All Tags Container -->
          <div class="horizontal-ac tags-wrapper">
            <!-- Trending Tag -->
            <div
              *ngIf="contentDetailInfo?.contentTags?.includes('trending')"
              class="custom-tags horizontal-ac"
              [style]="'fontSize.21' | translate"
            >
              {{ contentDetailInfo?.contentTags }}
            </div>

            <!-- Custom Tags -->
            <div
              *ngFor="
                let tag of contentDetailInfo?.customTags;
                trackBy: trackByTagKey
              "
              class="custom-tags horizontal-ac"
              [style.height]="'1.563vw'"
              [style]="customTagFontSize(tag) | translate"
            >
              <app-icon *ngIf="tag.key === 'Rent'" icon="rent"></app-icon>
              <span>{{ tag.value }}</span>
            </div>
          </div>

          <!-- 4K UHD -->
          <div
            *ngIf="contentDetailInfo?.is4k"
            class="quality-tag horizontal-ac"
            [style]="'fontSize.18' | translate"
            [style.height]="'1.563vw'"
          >
            4K UHD
          </div>

          <!-- Dolby Audio -->
          <div
            *ngIf="contentDetailInfo?.isDolbyAudio"
            class="dolby-audio horizontal-ac"
            [style.height]="'1.563vw'"
          >
            <app-icon icon="tag-dolby-audio"></app-icon>
          </div>

          <!-- Dolby Atmos -->
          <div
            *ngIf="contentDetailInfo?.isAtmos"
            class="dolby-atmos horizontal-ac"
            [style.height]="'1.563vw'"
          >
            <app-icon icon="tag-dolby-atmos"></app-icon>
          </div>
        </div>

        <!-- Ratings -->
        <div
          *ngIf="currentResource?.ratings?.length > 0"
          class="rating-tag horizontal-ac"
          [style]="'fontSize.18' | translate"
        >
          {{ currentResource?.ratings[0]?.v?.toUpperCase() }}
        </div>

        <!-- Description Section -->
        <ng-container *ngIf="contentDetailInfo?.advisories?.length">
          <div class="hero-details-data-description-general zoom-item">
            <div class="content-tag-hero" [style]="'fontSize.24' | translate">
              {{ contentDetailInfo?.heroTags }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="contentDetailInfo?.multiLingualAudio">
          <div class="multi-lingual-audio-container horizontal-ac zoom-item">
            <app-icon icon="tag-multi-lingual-audio"></app-icon>
            <span>{{ contentDetailInfo?.multiLingualAudio }}</span>
          </div>
        </ng-container>

        <!-- Move the carousel blocks here -->
        <!-- Modern carousel (Chromium 38+) -->
        <ng-container *ngIf="!isLegacyChromium; else legacyCarouselWrapper">
          <div
            class="carousel-track horizontal-focusable-container"
            data-down="horizontal-carousel-cards-0"
            (keydown)="onHeroKeyDown($event)"
            (click)="onClick()"
          >
            <!-- Fixed gradient overlays -->
            <div class="carousel-gradient-left"></div>
            <div class="carousel-gradient-right"></div>
            <!-- Active carousel border highlight -->
            <div
              class="carousel-active-border focusable-element"
              tabindex="0"
            ></div>
            <ng-container
              *ngFor="let item of carouselResources; let idx = index"
            >
              <button
                class="carousel-item"
                [ngClass]="
                  idx
                    | itemPositionClass
                      : carouselCurrentIndex
                      : carouselResources.length
                "
              >
                <img
                  [src]="item.image"
                  [alt]="item.title"
                  draggable="false"
                  loading="lazy"
                />
              </button>
            </ng-container>
          </div>
        </ng-container>

        <!-- Move only the legacy carousel block here -->
        <ng-template #legacyCarouselWrapper>
          <div
            class="carousel-scroll-wrapper carousel-track legacy-carousel horizontal-focusable-container"
            #legacyCarouselTrack
            data-down="horizontal-carousel-cards-0"
            (keydown)="onHeroKeyDown($event)"
            (click)="onClick()"
          >
            <!-- Fixed gradient overlays -->
            <div class="carousel-gradient-left"></div>
            <div class="carousel-gradient-right"></div>
            <!-- Active carousel border highlight -->
            <div
              class="carousel-active-border focusable-element"
              tabindex="0"
            ></div>
            <ng-container
              *ngFor="let item of carouselResources; let idx = index"
            >
              <button
                class="carousel-item"
                [ngClass]="
                  idx
                    | itemPositionClass
                      : carouselCurrentIndex
                      : carouselResources.length
                "
              >
                <img
                  [src]="item.image"
                  [alt]="item.title"
                  draggable="false"
                  loading="lazy"
                />
              </button>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #contentDetailTemplate>
      <div class="storefront-content-detail" *ngIf="currentResource">
        <app-content-detail
          [resource]="currentResource"
          [maxLines]="
            ['tvepisode', 'webepisode'].includes(
              currentResource?.contentType
            ) &&
            currentResource?.customTitleImage?.length &&
            currentResource?.title[lang]
              ? 2
              : 3
          "
        ></app-content-detail>
      </div>
    </ng-template>
  </div>
  <div
    class="storefront-carousel-container vertical-as"
    [class.card-type]="!isHeroFocused"
    tabindex="0"
    (keydown)="onCarouselKeydown($event)"
  >
    <ng-container
      *ngFor="
        let container of tempContainers;
        let i = index;
        trackBy: trackByContainerId
      "
    >
      <app-storefront-horizontal-carousel
        [containers]="container"
        [viewAllIndex]="VIEW_ALL_INDEX"
        [aspectRatio]="container?.aspectRatio"
        [showHeader]="true"
        [isTitleVisible]="false"
        [customId]="container?.id"
        (focusin)="isCardFocused(container, i)"
        (keydown.ArrowUp)="onArrowUp(i)"
        [index]="i"
        class="zoom-item"
        [inAppBanner]="container?.id === 'in-app-banner'"
        [canFocus]="canFocus"
      ></app-storefront-horizontal-carousel>
    </ng-container>
  </div>
</section>
